module.exports = __webpack_public_path__ + "static/media/PR.ad1a4f87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/PR.svg
// module id = 342
// module chunks = 0